import { apiSlice } from '@/store/api/apiSlice';

export interface PredictionAudioResponse {
  url: string;
  status?: string;
  message?: string;
}

export const predictionAudioApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPredictionAudio: builder.query<
      PredictionAudioResponse,
      { predictionId: string; language?: string }
    >({
      query: ({ predictionId, language }) => ({
        url: `predictions/${predictionId}/audio`,
        method: 'GET',
        params: { language: language || 'English' },
      }),
    }),
  }),
});

export const { useGetPredictionAudioQuery, useLazyGetPredictionAudioQuery } = predictionAudioApi;
